var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 19.5a2.12 2.12 0 0 1-1.56-.64 2.13 2.13 0 0 1-.638-1.566q0-.926.638-1.566t1.56-.64q.922 0 1.56.64.637.64.637 1.566 0 .927-.637 1.566-.638.64-1.56.64m0-9.706q1.649 0 3.132.53a9.8 9.8 0 0 1 2.691 1.455q.44.331.451.872t-.385.937a1.3 1.3 0 0 1-.922.386 1.62 1.62 0 0 1-.99-.297 7.2 7.2 0 0 0-1.845-.905 6.8 6.8 0 0 0-2.132-.33q-1.12 0-2.132.33-1.01.33-1.846.905a1.57 1.57 0 0 1-.988.286 1.33 1.33 0 0 1-.923-.397 1.32 1.32 0 0 1-.374-.937q0-.54.44-.872a9.6 9.6 0 0 1 2.691-1.444A9.4 9.4 0 0 1 12 9.794M12 4.5q2.747 0 5.175.904a14.4 14.4 0 0 1 4.362 2.56q.44.375.462.926t-.374.948a1.3 1.3 0 0 1-.923.386 1.5 1.5 0 0 1-.989-.342A12.065 12.065 0 0 0 12 7.147a12.07 12.07 0 0 0-7.713 2.735q-.44.354-.99.342a1.3 1.3 0 0 1-.922-.386A1.22 1.22 0 0 1 2 8.89a1.24 1.24 0 0 1 .462-.927 14.4 14.4 0 0 1 4.362-2.559Q9.253 4.5 12 4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOutline);
export default __webpack_public_path__ + "static/media/wifi_outline.7e92d784ece5ef0280c84cb645e2339e.svg";
export { ForwardRef as ReactComponent };